// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Line3px(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Line3px" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.68945 19.1895L19.1895 2.68945L21.3108 4.81077L4.81077 21.3108L2.68945 19.1895Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Line3px.js.map